import { useDispatch } from 'react-redux';
import dynamic from 'next/dynamic';
import CustomLink from '@/bit/components/components.custom-link';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@/bit/components/components.text';
import {
  OPACITY_LAYOUT_COLORS,
  CONTENT_POSITION,
  IN_SCENE_EFFECT,
  OUT_SCENE_EFFECT,
} from '@/bit/components/components.modal';
import getDeviceKindDependsOnViewPort from '@gcloud-npm/utils.common.get-device-kind-depends-on-viewport';
import { DEVICE_KIND } from '@/constants/constant';
import { actions as modalActions } from '@/bit/reducers/reducers.modals-reducer';

export const DOWNLOAD_FILE_NAME = 'ResumenContrato';
export const PDF_LINK_TEXT = 'Descarga del resumen del contrato (PDF).';

function ProvisionalAgreementLink({ urlDocuments, className, cyData }) {
  const dispatch = useDispatch();
  const handleOnClick = () => {
    if (Array.isArray(urlDocuments)) {
      const deviceKind = getDeviceKindDependsOnViewPort();
      const ModalProvisionalAgreementLink = dynamic(() =>
        import('@/modals/provisionalAgreementList')
      );
      dispatch(
        modalActions.addModal({
          createAnchor: false,
          type: 'MODAL',
          id: 'ModalProvisionalAgreementLink',
          Element2Show: ModalProvisionalAgreementLink,
          elementProps: { provisionalAgreementList: urlDocuments },
          modalProps: {
            opacityLayoutColor: OPACITY_LAYOUT_COLORS.BLACK05,
            contentPosition:
              deviceKind === DEVICE_KIND.MOBILE
                ? CONTENT_POSITION.CENTER_BOTTOM
                : CONTENT_POSITION.RIGHT_CENTER,
            inSceneEffect:
              deviceKind === DEVICE_KIND.MOBILE
                ? IN_SCENE_EFFECT.FADE_IN_BOTTOM
                : IN_SCENE_EFFECT.FADE_IN_RIGHT,
            outSceneEffect:
              deviceKind === DEVICE_KIND.MOBILE
                ? OUT_SCENE_EFFECT.FADE_OUT_BOTTOM
                : OUT_SCENE_EFFECT.FADE_OUT_RIGHT,
            closeByClickingOutside: true,
            contentInsideContainer: false,
          },
        })
      );
    }
  };
  return (
    <CustomLink
      onClick={handleOnClick}
      taggingInfo={{
        componentVariation: 'all',
        componentContent: PDF_LINK_TEXT,
        componentProduct: '',
        componentName: 'link',
      }}
      className={className}
      cyData={cyData}
    >
      <Text
        text={PDF_LINK_TEXT}
        size={TEXT_SIZE.CAPTION2}
        color={TEXT_COLOR.BLUEA}
      />
    </CustomLink>
  );
}

export default ProvisionalAgreementLink;
